module.exports = __webpack_public_path__ + "img/sign_right.0e60c5f4.png";